import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface ModalsState {
  isNewVendorOrderModalVisible: boolean
  isNewOrderModalVisible: boolean
  isEditOrderModalVisible: boolean
  isNewOrderModalVisibleOld: boolean
  isEditOrderModalVisibleOld: boolean
  isMissingModalForVendorVisible: boolean
  isTermsOfUseModalVisible: boolean
  isShippingWarningModalVisible: boolean
  isDamageDeviceModalForVendorVisible: boolean
  isUndamageDeviceModalForVendorVisible: boolean
  isAddWarehouseModalVisible: boolean
  isTransferDeviceModalVisible: boolean
  isReturnToWarehouseModalVisible: boolean
  isWarrantyModalVisible: boolean
  isDeviceHistoryLogModalVisible: boolean
  isAccountSettingsModalVisible: boolean
  isPerformanceTestConfirmModalVisible: boolean
  isPerformanceTestFailModalVisible: boolean
  isPerformanceTestReportModalVisible: boolean
  isSeeMessageModalVisible: boolean
  isTrackPackageModalVisible: boolean
}

const initialState: ModalsState = {
  isNewVendorOrderModalVisible: false,
  isNewOrderModalVisible: false,
  isEditOrderModalVisible: false,
  isNewOrderModalVisibleOld: false,
  isEditOrderModalVisibleOld: false,
  isMissingModalForVendorVisible: false,
  isTermsOfUseModalVisible: false,
  isShippingWarningModalVisible: false,
  isDamageDeviceModalForVendorVisible: false,
  isUndamageDeviceModalForVendorVisible: false,
  isAddWarehouseModalVisible: false,
  isTransferDeviceModalVisible: false,
  isReturnToWarehouseModalVisible: false,
  isWarrantyModalVisible: false,
  isDeviceHistoryLogModalVisible: false,
  isAccountSettingsModalVisible: false,
  isPerformanceTestConfirmModalVisible: false,
  isPerformanceTestFailModalVisible: false,
  isPerformanceTestReportModalVisible: false,
  isSeeMessageModalVisible: false,
  isTrackPackageModalVisible: false,
}

export const modalsSlise = createSlice({
  name: "modals",
  initialState,
  reducers: {
    showNewOrderModal: (state, action: PayloadAction<boolean>) => {
      state.isNewOrderModalVisible = action.payload
    },
    showNewOrderModalOld: (state, action: PayloadAction<boolean>) => {
      state.isNewOrderModalVisibleOld = action.payload
    },
    showEditOrderModal: (state, action: PayloadAction<boolean>) => {
      state.isEditOrderModalVisible = action.payload
    },
    showEditOrderModalOld: (state, action: PayloadAction<boolean>) => {
      state.isEditOrderModalVisibleOld = action.payload
    },
    showMissingModalForVendor: (state, action: PayloadAction<boolean>) => {
      state.isMissingModalForVendorVisible = action.payload
    },
    showTermsOfUseModal: (state, action: PayloadAction<boolean>) => {
      state.isTermsOfUseModalVisible = action.payload
    },
    showShippingWarningModal: (state, action: PayloadAction<boolean>) => {
      state.isShippingWarningModalVisible = action.payload
    },
    showDamageDeviceModalForVendor: (state, action: PayloadAction<boolean>) => {
      state.isDamageDeviceModalForVendorVisible = action.payload
    },
    showUndamageDeviceModalForVendor: (state, action: PayloadAction<boolean>) => {
      state.isUndamageDeviceModalForVendorVisible = action.payload
    },
    showAddWarehouseModal: (state, action: PayloadAction<boolean>) => {
      state.isAddWarehouseModalVisible = action.payload
    },
    showTransferDeviceModal: (state, action: PayloadAction<boolean>) => {
      state.isTransferDeviceModalVisible = action.payload
    },
    showReturnToWarehouseModal: (state, action: PayloadAction<boolean>) => {
      state.isReturnToWarehouseModalVisible = action.payload
    },
    showWarrantyModal: (state, action: PayloadAction<boolean>) => {
      state.isWarrantyModalVisible = action.payload
    },
    showDeviceHistoryLogModal: (state, action: PayloadAction<boolean>) => {
      state.isDeviceHistoryLogModalVisible = action.payload
    },
    showAccountSettingsModal: (state, action: PayloadAction<boolean>) => {
      state.isAccountSettingsModalVisible = action.payload
    },
    showPerformanceTestConfirmModal: (state, action: PayloadAction<boolean>) => {
      state.isPerformanceTestConfirmModalVisible = action.payload
    },
    showPerformanceTestFailModal: (state, action: PayloadAction<boolean>) => {
      state.isPerformanceTestFailModalVisible = action.payload
    },
    showPerformanceTestReportModal: (state, action: PayloadAction<boolean>) => {
      state.isPerformanceTestReportModalVisible = action.payload
    },
    showSeeMessageModal: (state, action: PayloadAction<boolean>) => {
      state.isSeeMessageModalVisible = action.payload
    },
    showTrackPackageModal: (state, action: PayloadAction<boolean>) => {
      state.isTrackPackageModalVisible = action.payload
    },
  },
})

export const {
  showNewOrderModal,
  showEditOrderModal,
  showNewOrderModalOld,
  showEditOrderModalOld,
  showMissingModalForVendor,
  showTermsOfUseModal,
  showShippingWarningModal,
  showDamageDeviceModalForVendor,
  showUndamageDeviceModalForVendor,
  showAddWarehouseModal,
  showTransferDeviceModal,
  showReturnToWarehouseModal,
  showWarrantyModal,
  showDeviceHistoryLogModal,
  showAccountSettingsModal,
  showPerformanceTestConfirmModal,
  showPerformanceTestFailModal,
  showPerformanceTestReportModal,
  showSeeMessageModal,
  showTrackPackageModal,
} = modalsSlise.actions

export default modalsSlise.reducer
